import * as React from "react"
import kebabCase from "lodash/kebabCase"
import Button from "./Button"
import styled from "styled-components"
import Section from "./Section"

const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
`

const Filters = ({ tags, currentTag }) => {
  return (
    <Section style={{ paddingTop: 40, paddingBottom: 0 }}>
      <FiltersContainer>
        {currentTag === "all" ? (
          <Button
            style={{
              whiteSpace: "nowrap",
              color: "var(--primary100)",
            }}
          >
            All Posts
          </Button>
        ) : (
          <Button
            url="/blog"
            style={{
              whiteSpace: "nowrap",
            }}
          >
            All Posts
          </Button>
        )}
        {tags.map(tag => {
          if (tag.fieldValue === currentTag) {
            return (
              <Button
                style={{
                  whiteSpace: "nowrap",
                  color: "var(--primary100)",
                }}
              >
                {tag.fieldValue} ({tag.totalCount})
              </Button>
            )
          } else {
            return (
              <Button
                url={`/blog/${kebabCase(tag.fieldValue)}/`}
                key={tag.fieldlValue}
                style={{
                  whiteSpace: "nowrap",
                }}
              >
                {tag.fieldValue} ({tag.totalCount})
              </Button>
            )
          }
        })}
      </FiltersContainer>
    </Section>
  )
}

export default Filters
